<button type="button" class="promo-card">
  <div class="promo-top">
    <img class="promo-image" [src]="banner.image.data.full_url"
         (click)="navigateTo(banner.image_link)" alt="">
  </div>
</button>
